import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import '../../styles/Navbar.css';
import PhoneNumberPopup from '../PhoneNumberPopup';
import theFoxCuts from '../../TheFoxCuts.webp';
import theFoxMini from '../../TheFoxMini.png';
import luvwtfLogo from '../../luvwtf2.png';

const Navbar = ({ onShowSurvey, onShowLoginPopup, onFocusThoughtInput, onShowSignUp, currentUser, cartCount = 0, onCartClick, onPostersClick, onYourRewardsClick, onRedeemCouponClick, onCollageFriendClick, onFindsClick, onMessagesClick, unreadMessagesCount = 0, onSignOut, forceSignedOutView = false, userPhotoUrl = null, onLogoClick, isPrelaunch = false }) => {
  const [showPhonePopup, setShowPhonePopup] = useState(false);
  const [showMiniHeart, setShowMiniHeart] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [showBalanceMenu, setShowBalanceMenu] = useState(false);
  const [balanceMenuPosition, setBalanceMenuPosition] = useState({ top: 0, left: 0 });
  const [userPhotoLoadError, setUserPhotoLoadError] = useState(false);
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);
  const userMenuRef = useRef(null);
  const balanceMenuRef = useRef(null);

  useEffect(() => {
    setUserPhotoLoadError(false);
  }, [userPhotoUrl]);

  useEffect(() => {
    if (isPrelaunch) return;
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
      const heartintelImage = document.querySelector('.heartintel-image');
      if (heartintelImage) {
        const heartintelRect = heartintelImage.getBoundingClientRect();
        setShowMiniHeart(heartintelRect.bottom <= 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isPrelaunch]);

  const handleSignUp = (e) => {
    e.preventDefault();
    if (onShowSignUp) {
      onShowSignUp(undefined, 'navbar');
    }
  };

  const handleSignIn = (e) => {
    e.preventDefault();
    if (onShowLoginPopup) {
      onShowLoginPopup();
    }
  };

  const handleScrollToTop = (e) => {
    e.preventDefault();
    onLogoClick?.();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if (!showUserMenu) return;
    const handleClickOutside = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target) && !e.target.closest('.navbar-user-menu-portal')) {
        setShowUserMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showUserMenu]);

  useEffect(() => {
    if (!showBalanceMenu) return;
    const handleClickOutside = (e) => {
      if (balanceMenuRef.current && !balanceMenuRef.current.contains(e.target) && !e.target.closest('.navbar-balance-menu-portal')) {
        setShowBalanceMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showBalanceMenu]);

  const handleUserIconClick = () => {
    if (!showUserMenu && userMenuRef.current) {
      const rect = userMenuRef.current.getBoundingClientRect();
      const menuWidth = 160; // min-width 10rem
      setMenuPosition({
        top: rect.bottom + 4,
        left: rect.right - menuWidth
      });
    }
    setShowUserMenu((prev) => !prev);
  };

  const handleCartOption = () => {
    setShowUserMenu(false);
    onCartClick?.();
  };

  const handlePostersOption = () => {
    setShowUserMenu(false);
    onPostersClick?.();
  };

  const handleYourRewardsOption = () => {
    setShowUserMenu(false);
    onYourRewardsClick?.();
  };

  const handleRedeemCouponOption = () => {
    setShowUserMenu(false);
    onRedeemCouponClick?.();
  };

  const handleCollageFriendOption = () => {
    setShowUserMenu(false);
    onCollageFriendClick?.();
  };

  const handleFindsOption = () => {
    setShowUserMenu(false);
    onFindsClick?.();
  };

  const handleSignOutOption = () => {
    setShowUserMenu(false);
    onSignOut?.();
  };

  const handleBalanceClick = () => {
    if (!showBalanceMenu && balanceMenuRef.current) {
      const rect = balanceMenuRef.current.getBoundingClientRect();
      const menuWidth = 160;
      setBalanceMenuPosition({
        top: rect.bottom + 4,
        left: rect.right - menuWidth
      });
    }
    setShowBalanceMenu((prev) => !prev);
  };

  const handleBalanceEarnFoxes = () => {
    setShowBalanceMenu(false);
    const el = document.getElementById('earn-foxes');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleBalanceCart = () => {
    setShowBalanceMenu(false);
    onCartClick?.();
  };

  return (
    <>
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-left">
          <div className="navbar-brand-fox-row">
            <a href="#" className={`navbar-left-brand ${showMiniHeart ? 'transformed' : ''}`} onClick={handleScrollToTop}>
              <img src={luvwtfLogo} alt="WHAT THE FOX" className="navbar-logo" />
            </a>
            <button
              type="button"
              className="navbar-inline-video-fox"
              aria-label="Play video"
              onClick={() => setShowVideoPlayer(true)}
            >
              <img
                src={theFoxMini}
                alt=""
                className="navbar-video-fox-icon"
                aria-hidden
              />
            </button>
          </div>
          <div className={`mini-heart-container ${showMiniHeart ? 'visible' : ''}`}>
            <img src="/heartintel.svg" alt="Intelligence Heart" className="mini-heart" />
          </div>
        </div>
        <div className="navbar-right">
          {currentUser && !forceSignedOutView ? (
            <>
              <div className="navbar-messages-wrap">
                {unreadMessagesCount > 0 && (
                  <span className="navbar-messages-badge">{unreadMessagesCount}</span>
                )}
                <button type="button" className="navbar-messages-button" aria-label="Messages" onClick={onMessagesClick}>
                  Messages
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="navbar-messages-arrow" aria-hidden>
                    <path d="M7 17 17 7M7 7h10v10" />
                  </svg>
                </button>
              </div>
              <div className="navbar-cart-wrap" ref={userMenuRef}>
                {cartCount > 0 && (
                  <span className="navbar-cart-badge">{cartCount}</span>
                )}
                <button type="button" className="navbar-cart-button" aria-label="Profile" aria-expanded={showUserMenu} onClick={handleUserIconClick}>
                  <svg className="navbar-cart-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="8" r="4" />
                    <path d="M20 21a8 8 0 1 0-16 0" />
                  </svg>
                </button>
                {showUserMenu && createPortal(
                  <div className="navbar-user-menu navbar-user-menu-portal" style={{ position: 'fixed', top: menuPosition.top, left: menuPosition.left }}>
                    <div className="navbar-user-photo-wrap">
                      {userPhotoUrl && !userPhotoLoadError ? (
                        <div
                          className="navbar-user-photo navbar-user-photo--readonly"
                          aria-label="Profile photo from your primary collage"
                          role="img"
                        >
                          <img
                            src={userPhotoUrl}
                            alt=""
                            onError={() => setUserPhotoLoadError(true)}
                            className="navbar-user-photo-img"
                          />
                        </div>
                      ) : (
                        <button
                          type="button"
                          className="navbar-user-photo-add"
                          onClick={handlePostersOption}
                          aria-label="Open Your collages to add a photo to your primary collage"
                        >
                          Create your profile
                        </button>
                      )}
                    </div>
                    <button type="button" className="navbar-user-menu-item" onClick={handlePostersOption}>
                      Your home
                    </button>
                    <button type="button" className="navbar-user-menu-item" onClick={handleYourRewardsOption}>
                      Your rewards
                    </button>
                    {typeof onRedeemCouponClick === 'function' ? (
                      <button type="button" className="navbar-user-menu-item" onClick={handleRedeemCouponOption}>
                        Redeem coupon
                      </button>
                    ) : null}
                    {typeof onCollageFriendClick === 'function' ? (
                      <button type="button" className="navbar-user-menu-item" onClick={handleCollageFriendOption}>
                        Collage a friend
                      </button>
                    ) : null}
                    <button type="button" className="navbar-user-menu-item" onClick={handleSignOutOption}>
                      Sign out
                    </button>
                  </div>,
                  document.body
                )}
              </div>
            </>
          ) : (
            <div className="navbar-auth-wrap">
              <div className="nav-links">
                <a href="#" className="nav-link" onClick={handleSignUp}>
                  Sign Up
                  <svg 
                    width="24" 
                    height="24" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    className="arrow-icon"
                  >
                    <path d="M7 17 17 7M7 7h10v10" />
                  </svg>
                </a>
              </div>
              <a href="#" className="sign-in-button" onClick={handleSignIn}>Sign In</a>
            </div>
          )}
        </div>
      </div>
    </nav>

      {showVideoPlayer && createPortal(
        <div className="navbar-video-overlay" onClick={() => setShowVideoPlayer(false)}>
          <div className="navbar-video-collage" onClick={(e) => e.stopPropagation()}>
            <div className="navbar-video-tape navbar-video-tape-top" />
            <div className="navbar-video-tape navbar-video-tape-bottom" />
            <button
              type="button"
              className="navbar-video-close"
              onClick={() => setShowVideoPlayer(false)}
              aria-label="Close video"
            >
              &times;
            </button>
            <div className="navbar-video-frame">
              <iframe
                src="https://www.youtube.com/embed/h_7nu4Dl0OQ?autoplay=1"
                title="Video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>,
        document.body
      )}

      {showPhonePopup && (
        <PhoneNumberPopup onClose={() => setShowPhonePopup(false)} />
      )}
    </>
  );
};

export default Navbar; 